/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */

import { gql } from '@apollo/client'
import { PERMISSION_FRAGMENT } from '../fragments/PermissionFragment'

export const GET_PERMISSIONS = gql`
  query GetPermissions($input: PaginationInput) {
    permissions(input: $input) {
      results {
        ...Permission
      }
      count
      hasMore
    }
  }
  ${PERMISSION_FRAGMENT}
`
